import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const WarningCircleSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 20 20",
  color = "#B4730C",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M10 0C4.478 0 0 4.478 0 10c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10zm0 16.383c-.782 0-1.317-.602-1.317-1.383 0-.803.558-1.383 1.317-1.383.803 0 1.317.58 1.317 1.383 0 .782-.514 1.383-1.317 1.383zm.518-5.282c-.199.679-.826.69-1.036 0-.24-.797-1.096-3.821-1.096-5.785 0-2.592 3.242-2.604 3.242 0 0 1.976-.902 5.078-1.11 5.785z"
        fill={color}
      />
    </svg>
  );
};

export { WarningCircleSvg };
